import { required, SelectInput } from "react-admin";
import React from "react";
import {subcontractorsAdhocCategoryList} from "../const";

interface ISubcontractorAdhocCategoryInput {
  source?: string;
  label?: string;
  isRequired?: boolean;
}

const SubcontractorAdhocCategoryInput = ({
  source = "category",
  label = "Category",
  isRequired = true
}: ISubcontractorAdhocCategoryInput) => {
  return (
    <SelectInput
      source={source}
      label={label}
      choices={subcontractorsAdhocCategoryList}
      validate={isRequired ? required() : undefined}
    />
  );
};

export default SubcontractorAdhocCategoryInput;
